import { render, staticRenderFns } from "./festtheme.vue?vue&type=template&id=4475bebf"
import script from "./festtheme.vue?vue&type=script&lang=js"
export * from "./festtheme.vue?vue&type=script&lang=js"
import style0 from "./festtheme.vue?vue&type=style&index=0&id=4475bebf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports